// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"9e44b073","226":"50938948","316":"9126214d","453":"834cab79","731":"2e227a29"}[chunkId] + ".chunk.js";
};